
import React, { useEffect, useRef, useState } from "react";
import './Main.css';
import SaveOrder from '../assets/saveOrder.png';
import QuickBilling from '../assets/quickBilling.png';
import ReportIcon from '../assets/report.png';
import InventoryIcon from '../assets/inventory.png';

const Services = () => {

    const [mobileView, setMobileView]: any = useState<boolean>(
        window.innerWidth <= 768
    );

    useEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 768)
                setMobileView(true);
            else
                setMobileView(false);
        }
        window.addEventListener("resize", updateSize);
    }, [mobileView]);

    return (
        <div style={{background:'#f6f6f6'}} id="services">
        <div className="mainServiceContainer">
            <div style={{width:mobileView?'100%':'45%',}}>
           <h1 style={{fontSize:mobileView?26:'3.25vw',color:'#000',fontWeight:'bold',letterSpacing:2,textAlign:mobileView?'center':'left'}}>Our Sabka POS<br />App Services</h1>
           <p className="serviceDescription">
           POS typically stands for Point of Sale, which refers to the location where a transaction takes place. It could be a physical retail store, an online shop, or any other venue where goods or services are exchanged for payment. This app services could refer to various services provided through mobile applications. These services can include anything from e-commerce transactions, Food Delivery, Gift Shop, Furniture Store, Clothing Store, Coffee Shop to digital banking, and beyond.
           </p>
           </div>
           <div className="serviceGridContainer">
               <div>
                <div className="serviceIcon">
                    <img src={QuickBilling} alt="" />
                </div>
                <h4 className="serviceName">
                Quick Billing
                </h4>
                <div className="serviceDetail">
                Generate speedy bills with Quick Bill, a hassle-free billing method designed for customers without the need to add products to the inventory.
                </div>
               </div>
               <div>
                <div className="serviceIcon">
                    <img src={InventoryIcon} alt="" />
                </div>
                <h4 className="serviceName">
                Inventory Management
                </h4>   
                <div className="serviceDetail">
                Optimize your inventory management with Sabka POS. Effortlessly track stock levels. Enhance efficiency, reduce costs, and ensure smooth operations
                </div>
               </div>
               <div>
               <div className="serviceIcon">
                    <img src={SaveOrder} alt="" />
                </div>
                <h4 className="serviceName">
                Saved Order
                </h4>
                <div className="serviceDetail">
               Users can view details of any saved order, including the order name and number, order total, and the items in the saved order.
                </div>
               </div>
               <div>
               <div className="serviceIcon">
                    <img src={ReportIcon} alt="" />
                </div>
                <h4 className="serviceName">
                Reports
                </h4>
                <div className="serviceDetail">
                Access comprehensive reports and analytics with Billeez, providing valuable insights into your business performance.
                </div>
               </div>
             
           </div>
        </div>
        </div>
    );
};

export default Services;
